<div class="container-fluid">
	<div class="row">
		<app-sidebar class="sidebar col pl-0"></app-sidebar>
		<ui-view class="content-wrapper col"></ui-view>
	</div>
</div>